import { useSharedScanRawAlarm } from '@hakimo-ui/hakimo/data-access';
import { QueryResult } from '@hakimo-ui/hakimo/ui-elements';
import { Alert } from '@hakimo-ui/shared/ui-base';
import ScanRawAlarmDetails from './ScanRawAlarmDetails';

interface Props {
  sharedToken: string;
}

export function SharedRawAlarmDetails({ sharedToken }: Props) {
  const queryResult = useSharedScanRawAlarm(sharedToken);
  const { refetch } = queryResult;

  return (
    <QueryResult
      queryResult={queryResult}
      errorFormatter={() => (
        <div className="mx-auto max-w-screen-2xl p-6">
          <Alert type="error">
            This link is expired or invalid. Please ask the sender for a new
            link.
          </Alert>
        </div>
      )}
    >
      {(data) => (
        <ScanRawAlarmDetails
          event={data}
          sharedToken={sharedToken}
          onRefresh={() => refetch()}
        />
      )}
    </QueryResult>
  );
}
